"use client";

import { useTranslations } from "next-intl";
import { Link } from "@/i18n/navigation";

const MAIN_CONTENT_ID = "main-content";

export function getMainContentId() {
	return MAIN_CONTENT_ID;
}

export default function SkipToMainContent() {
	const t = useTranslations("Accessibility");

	return (
		<Link
			href={`#${MAIN_CONTENT_ID}`}
			className="skip-link"
			tabIndex={0}
		>
			{t("skipToMain")}
		</Link>
	);
}
